import React, { FC, useEffect, useState, useMemo } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Datatable from "containers/Admin/Contact/Datatable";
import { useDispatch, useSelector } from "react-redux";
import withRouter from "components/Common/withRouter";
import {
  getList as onGetList,
  updateData as onUpdateData,
  addNewData as onAddNewData,
  getData as onGetData,
  clearData
} from "store/AppMaster/actions";
import api from "constants/api";
import { RootState } from 'store/reducers';
import {
  Typography,
  Button,
  Avatar,
} from "@material-tailwind/react";
import moment from 'moment';
import ButtonPrimary from "shared/Button/ButtonPrimary";
import * as Yup from "yup";
import { useFormik } from "formik";
import toastr from "toastr";
import axios from "axios";
import { set } from "lodash";
import Swal from 'sweetalert2';
import ButtonDropdown from "components/ButtonDropdown";


export interface CreateProps {
  getGroupDetails: () => void;
  updatedeliveryPartner?: any;
  setUpdatedeliveryPartner?: any;
  setShow?: any;
  setIsApiCall?: any;
}

export interface AdminUserProps {
  data: any;
  result: any[]
}


const Index: FC<AdminUserProps> = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isApiCall, setIsApiCall] = useState(0)
  const [listCount, setListCount] = useState(0);
  const [listData, setListData] = useState([]);
  const [editListData, setEditListData] = useState([]);
  const [updateListData, setUpdateListData] = useState(false);
  const [changeStatus, setChangeStatus] = useState('');
  const [showEditModalQuickView, setEditShowModalQuickView] = useState(false);
  const [statusOptions, setStatusOptions] = useState([

    { key: 'Active', value: 'Active' },
    { key: 'Inactive', value: 'Inactive' },
  ])
  const [isDelete, setDelete] = useState(false);
  const [fontList, setFontList] = useState<string[]>([]);
  const [filterData, setFilterData] = useState({
    start: 0,
    limit: 10,
    search: '',
    sort_by: "_id",
    sort_order: "desc",
  });

  // useEffect(() => {
  //   if (isApiCall == 0) {
  //     getListData();
  //     setIsApiCall(1);
  //   }
  // }, [isApiCall]);

  const { data } = useSelector((state: RootState) => state.AppMaster);

  const getListData = async () => {
    // setUpdateListData(true);
    dispatch(clearData())
    dispatch(onGetList(filterData, '', api.getSpecialMessageList));
  }

  useEffect(() => {
    getListData();
  }, [location]);

  useEffect(() => {
    if (data && typeof data === 'object') {
      // setUpdateListData(false);
      setListData(Array.isArray(data.result) ? data.result : []);
      setListCount(data.total_count);
    }
  }, [data]);

  useEffect(() => {
    const fetchFonts = async () => {
      const apiKey = process.env.REACT_APP_GOOGLE_FONTS_API_KEY || "AIzaSyBwxglAR8bqGmldyXzHwPytQFdbj15xWD4";
      if (!apiKey) {
        console.warn("Google Fonts API Key is missing. Please add REACT_APP_GOOGLE_FONTS_API_KEY to your env.");
        // Fallback or empty
        return;
      }
      try {
        const response = await axios.get(
          `https://www.googleapis.com/webfonts/v1/webfonts?key=${apiKey}`
        );
        if (response.data && response.data.items) {
          // Take top 50 popular fonts to avoid overwhelming dropdown
          const fonts = response.data.items.map((item: any) => item.family);
          setFontList(fonts);
        }
      } catch (error) {
        console.error("Error fetching Google Fonts:", error);
      }
    };
    fetchFonts();
  }, []);

  const handleSearch = async (name: any, value: any) => {
    if (name === 'start') {
      // Update the start value in filterData
      setFilterData((prevFilterData) => ({
        ...prevFilterData,
        start: value,
      }));
    }

    if (name === 'search') {
      // Update the start value in filterData
      setFilterData((prevFilterData) => ({
        ...prevFilterData,
        search: value,
      }));
    }
    // Call the list API after updating the start value
    await getListData();
  };

  const columns = useMemo(
    () => [
      {
        Header: "Content",
        accessor: 'content',
      },
      {
        Header: "Link",
        accessor: 'hyperlink',
      },
      {
        Header: "Status",
        accessor: 'status',
      },
      {
        Header: "Action",
        Cell: (cellProps: any) => {
          return (
            <>
              <div className="flex gap-3">
                <a href={`/admin/special-message/edit/${cellProps.row.original._id}`}
                  className="text-secondary"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 576 512"><path d="M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z" /></svg>
                </a>
                <a href={`/admin/special-message/${cellProps.row.original._id}`}
                  className="text-secondary"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 192 512"><path d="M20 424.2h20V279.8H20c-11 0-20-9-20-20V212c0-11 9-20 20-20h112c11 0 20 9 20 20v212.2h20c11 0 20 9 20 20V492c0 11-9 20-20 20H20c-11 0-20-9-20-20v-47.8c0-11 9-20 20-20zM96 0C56.2 0 24 32.2 24 72s32.2 72 72 72 72-32.2 72-72S135.8 0 96 0z" /></svg>
                </a>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    deleteProduct('Deleted', cellProps.row.original._id);
                  }}
                  className="text-secondary"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 30 30">
                    <path d="M 14.984375 2.4863281 A 1.0001 1.0001 0 0 0 14 3.5 L 14 4 L 8.5 4 A 1.0001 1.0001 0 0 0 7.4863281 5 L 6 5 A 1.0001 1.0001 0 1 0 6 7 L 24 7 A 1.0001 1.0001 0 1 0 24 5 L 22.513672 5 A 1.0001 1.0001 0 0 0 21.5 4 L 16 4 L 16 3.5 A 1.0001 1.0001 0 0 0 14.984375 2.4863281 z M 6 9 L 7.7929688 24.234375 C 7.9109687 25.241375 8.7633438 26 9.7773438 26 L 20.222656 26 C 21.236656 26 22.088031 25.241375 22.207031 24.234375 L 24 9 L 6 9 z"></path>
                  </svg>
                </a>
              </div>
            </>
          );
        },
      }
    ],
    []
  );

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      content: "",
      hyperlink: "",
      status: "",
      colour_code: "#000000",
      font_style: "",
    },
    validationSchema: Yup.object({
      content: Yup.string()
        .required("Please enter Content"),
      hyperlink: Yup.string(),
      status: Yup.string()
        .required("Please select Status"),
      colour_code: Yup.string()
        .required("Please select a color"),
      font_style: Yup.string()
        .required("Please select a font style"),
    }),
    onSubmit: async (values) => {
      const newData = {
        hyperlink: values.hyperlink,
        content: values.content,
        status: values.status,
        colour_code: values.colour_code,
        font_style: values.font_style,
      };
      // dispatch(onAddNewData(newData, '', api.addSpecialMessage));
      const url =
        process.env.REACT_APP_API_URL + api.addSpecialMessage;
      const headers = {
        "Content-Type": "application/json",
        // @ts-ignore
        Authorization: `Bearer ${JSON.parse(localStorage.getItem("AuthUser"))}`,
      };
      const options = { headers: headers };
      try {
        const response = await axios.post(url, newData, options);

        if (response.data.statusCode === 200) {
          toastr.success(response.data.message);
          setIsApiCall(0)
          window.location.reload();
        } else {
          toastr.error(response.data.message || "An error occurred");
        }

        return response.data.statusCode;
      } catch (error: any) {

        const message =
          error?.response?.data?.message ||
          "An error occurred while processing your request";
        toastr.error(message);
        throw error;
      }
    },
  });

  const deleteProduct = (status: string, id: string) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result: any) => {
      if (result.isConfirmed) {
        // Call the delete function if the user confirms
        setDelete(true);
        const updateData = {
          id: id,
        };
        dispatch(onUpdateData(updateData, '', api.deleteSpecialMessage))
      }
    });
  }

  useEffect(() => {
    if (isDelete && data && !Array.isArray(data.result)) {
      setDelete(false);
      getListData();
    }
  }, [data, isDelete]);


  return (
    <div className="container py-16 lg:pb-28 lg:pt-20">
      <Helmet>
        <title>Special Message</title>
      </Helmet>
      <div className="mb-12 sm:mb-16">
        <h2 className="block text-2xl sm:text-3xl lg:text-4xl font-semibold ">Special Message</h2>
      </div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();

          return false;
        }}
      >
        <div className="p-4">
          {/* Code Input */}
          <div className="mb-4">
            <label
              htmlFor="productPrice"
              className="block text-sm font-medium text-gray-700"
            >
              Enter the content of Special Message
            </label>
            <input
              id="content"
              type="text"
              className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              // onChange={onChangeHandler}
              name="content"
              value={validation.values.content}
              onChange={validation.handleChange}
            />
            {validation.touched.content && validation.errors.content ? (
              <div className="text-red-500 text-sm mt-1">
                {validation.errors.content}
              </div>
            ) : null}
          </div>
          <div className="mb-4">
            <label
              htmlFor="productPrice"
              className="block text-sm font-medium text-gray-700"
            >
              Enter the link of Special Message
            </label>
            <input
              id="hyperlink"
              type="text"
              className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              //   onChange={onChangeHandler}
              name="hyperlink"
              value={validation.values.hyperlink}
              onChange={validation.handleChange}
            />
            {validation.touched.hyperlink && validation.errors.hyperlink ? (
              <div className="text-red-500 text-sm mt-1">
                {validation.errors.hyperlink}
              </div>
            ) : null}
          </div>
          <div className="mb-4">
            <label
              htmlFor="status"
              className="block text-sm font-medium text-gray-700"
            >
              Select Status
            </label>
            <select
              id="status"
              name="status"
              className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              value={validation.values.status}
              onChange={validation.handleChange}
            >
              <option value="">Select Status</option>
              {statusOptions.map((option) => (
                <option key={option.key} value={option.key}>
                  {option.value}
                </option>
              ))}
            </select>
            {validation.touched.status && validation.errors.status ? (
              <div className="text-red-500 text-sm mt-1">
                {validation.errors.status}
              </div>
            ) : null}
          </div>
          <div className="mb-4">
            <label
              htmlFor="colour_code"
              className="block text-sm font-medium text-gray-700"
            >
              Select Text Color
            </label>
            <div className="flex items-center gap-3 mt-1">
              <input
                id="colour_code"
                type="color"
                className="h-10 w-20 border border-gray-300 rounded-md cursor-pointer"
                name="colour_code"
                value={validation.values.colour_code}
                onChange={validation.handleChange}
              />
              <input
                type="text"
                className="focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                value={validation.values.colour_code}
                onChange={(e) => validation.setFieldValue('colour_code', e.target.value)}
                placeholder="#000000"
              />
            </div>
            {validation.touched.colour_code && validation.errors.colour_code ? (
              <div className="text-red-500 text-sm mt-1">
                {validation.errors.colour_code}
              </div>
            ) : null}
          </div>
          <div className="mb-4">
            <label
              htmlFor="font_style"
              className="block text-sm font-medium text-gray-700"
            >
              Select Font Style
            </label>
            <select
              id="font_style"
              name="font_style"
              className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              value={validation.values.font_style}
              onChange={validation.handleChange}
            >
              <option value="">Select Font Style</option>
              {fontList.length > 0 ? (
                fontList.map((font) => (
                  <option key={font} value={font} style={{ fontFamily: font }}>
                    {font}
                  </option>
                ))
              ) : (
                <>
                  <option value="Roboto">Roboto (Default)</option>
                  <option disabled>Loading or No API Key...</option>
                </>
              )}
            </select>
            {validation.touched.font_style && validation.errors.font_style ? (
              <div className="text-red-500 text-sm mt-1">
                {validation.errors.font_style}
              </div>
            ) : null}
          </div>

          <div className="text-center mt-3">
            <ButtonPrimary type="submit">
              <span>Submit</span>
            </ButtonPrimary>
          </div>
        </div>
      </form>

      <div className="mt-8 sm:mt-10 mb-8 sm:mb-10">
        <Datatable
          listData={listData}
          filterData={filterData}
          getListData={getListData}
          listCount={listCount}
          columns={columns}
          editData={editListData}
          handleSearch={handleSearch}
        />
      </div>
    </div>
  );
};

export default withRouter(Index);